import { render, staticRenderFns } from "./IButton.vue?vue&type=template&id=7e7330a3&scoped=true"
import script from "./IButton.vue?vue&type=script&lang=ts"
export * from "./IButton.vue?vue&type=script&lang=ts"
import style0 from "./IButton.vue?vue&type=style&index=0&id=7e7330a3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7330a3",
  null
  
)

export default component.exports